import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { io, Socket } from "socket.io-client";
import { API_CONFIG_TOKEN, ApiConfig } from "../../providers";

@Injectable()
export class ApiSocketService {
  readonly connected$ = new BehaviorSubject(false);
  readonly disconnect$ = new Subject<string>();
  readonly connectError$ = new Subject<Error>();
  readonly socket: Socket;

  constructor(@Inject(API_CONFIG_TOKEN) private readonly apiConfig: ApiConfig) {
    this.socket = io(this.apiConfig.socketUrl!, {
      transports: ["websocket"],
      reconnectionDelay: 15_000,
      reconnectionDelayMax: 15_000,
      randomizationFactor: 1,
      closeOnBeforeunload: false,
      autoConnect: false
    });

    this.socket.on("connect", () => this.connected$.next(true));
    this.socket.on("connect_error", (error: Error) =>
      this.connectError$.next(error)
    );
    this.socket.on("disconnect", this.onDisconnect);
  }

  connect(token: string) {
    this.socket.disconnect();

    this.socket.io.opts.query = {
      ...(this.socket.io.opts.query || {}),
      token
    };
    this.socket.connect();
  }

  disconnect() {
    this.socket.disconnect();
  }

  private onDisconnect = (reason: string) => {
    this.disconnect$.next(reason);
    this.connected$.next(false);
  };
}
